import { RailItemConfig } from 'app/shared/models/rail-item.model';
import { PERMISSION_ROLE_MANAGE } from 'app/shared/services/permissions/permissions.constants';
import {
  FEATURE_FLAG_ABC_ANALYSIS,
  FEATURE_FLAG_ACCESS_CONTROL,
  FEATURE_FLAG_AGENT_LIBRARY,
  FEATURE_FLAG_CONSTRAINED_SERVICE_LEVEL_OPTIMIZATION,
  FEATURE_FLAG_DEMAND_FORECASTING,
  FEATURE_FLAG_DEMAND_PREDICTION,
  FEATURE_FLAG_DEO_AGENT,
  FEATURE_FLAG_INVENTORY_OPTIMIZATION,
  FEATURE_FLAG_DEMAND_PLANNING,
  FEATURE_FLAG_LEAD_TIME_PREDICTION,
  FEATURE_FLAG_OPTIMAL_REPLENISHMENT_QUANTITY,
  FEATURE_FLAG_SUPPLY_VARIABILITY,
  FEATURE_FLAG_NOTIFICATION,
  FEATURE_FLAG_TOOLS,
  FEATURE_FLAG_DEFAULT_SETTINGS,
  FEATURE_FLAG_HOME,
  FEATURE_FLAG_FAVORITES
} from 'app/shared/services/feature-flags/feature-flags.constants';

export const GAINS_SIDENAV_ITEMS = [
  {
    menu: 'Home',
    icon: 'assets/icons/home.svg',
    routerLink: '/home',
    routerLinkActive: 'active',
    featureFlag: FEATURE_FLAG_HOME,
    subMenu: []
  },
  {
    menu: 'DEO AI Assist',
    icon: 'assets/icons/deo-agent.svg',
    routerLink: '/deo-ai-assist',
    routerLinkActive: 'active',
    featureFlag: FEATURE_FLAG_DEO_AGENT,
    subMenu: []
  },
  {
    menu: 'Favorites',
    icon: 'assets/icons/favorites.svg',
    routerLink: '/1',
    routerLinkActive: '',
    featureFlag: FEATURE_FLAG_FAVORITES,
    subMenu: [
      {
        name: 'Fav1',
        routerLink: '/home',
        routerLinkActive: 'active'
      },
      {
        name: 'Fav2',
        routerLink: '/home',
        routerLinkActive: 'active'
      }
    ]
  },
  {
    menu: 'Demand Planning',
    icon: 'assets/icons/demand-planning.svg',
    routerLink: '',
    routerLinkActive: '',
    featureFlag: FEATURE_FLAG_DEMAND_PLANNING,
    subMenu: [
      {
        name: 'Demand Forecasting',
        routerLink: '/demand-forecasting',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_DEMAND_FORECASTING
      },
      {
        name: 'Demand Prediction',
        routerLink: '/demand-prediction',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_DEMAND_PREDICTION
      }
    ]
  },
  {
    menu: 'Inventory Optimization',
    icon: 'assets/icons/inventory-optimization.svg',
    routerLink: '',
    routerLinkActive: '',
    featureFlag: FEATURE_FLAG_INVENTORY_OPTIMIZATION,
    subMenu: [
      {
        name: 'ABC Analysis',
        routerLink: '/abc-analysis',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_ABC_ANALYSIS
      },
      {
        name: 'Constrained Service Level Optimization',
        routerLink: '/cslo',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_CONSTRAINED_SERVICE_LEVEL_OPTIMIZATION
      },
      {
        name: 'Lead Time Prediction',
        routerLink: '/ltp',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_LEAD_TIME_PREDICTION
      },
      {
        name: 'Optimal Replenishment Quantity',
        routerLink: '/orq-ss',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_OPTIMAL_REPLENISHMENT_QUANTITY
      },
      {
        name: 'Supply Variability',
        routerLink: '/supply-variability',
        routerLinkActive: 'active',
        featureFlag: FEATURE_FLAG_SUPPLY_VARIABILITY
      }
    ]
  }
];

export const GAINS_SIDENAV_BOTTOMGROUP_ITEMS: RailItemConfig[] = [
  {
    menu: 'Agent Library',
    icon: 'assets/icons/agent-library.svg',
    routerLink: '/agent-library',
    routerLinkActive: 'active',
    featureFlag: FEATURE_FLAG_AGENT_LIBRARY
  },
  {
    menu: 'Tools',
    icon: 'assets/icons/tools.svg',
    routerLink: '/home',
    routerLinkActive: 'active',
    featureFlag: FEATURE_FLAG_TOOLS
  },
  {
    // No routerLink: this row opens the Alerts tray rather than navigating.
    menu: 'Notification',
    icon: 'assets/icons/notification.svg',
    featureFlag: FEATURE_FLAG_NOTIFICATION,
    action: 'open-notifications',
    badgeKey: 'notifications'
  },
  {
    menu: 'Access Control',
    icon: 'assets/icons/access-control.svg',
    routerLink: '/access-control',
    routerLinkActive: 'active',
    featureFlag: FEATURE_FLAG_ACCESS_CONTROL,
    permission: PERMISSION_ROLE_MANAGE
  },
  {
    menu: 'Default Settings',
    icon: 'assets/icons/settings.svg',
    routerLink: '/settings',
    routerLinkActive: 'active',
    featureFlag: FEATURE_FLAG_DEFAULT_SETTINGS
  }
];
